import { useTranslation } from 'react-i18next'
import { useApolloClient, useQuery } from '@apollo/client/react'

import { createCookie } from 'js/lib/cookies'

import { LanguagePickerDocument } from './LanguagePicker.generated'
import type { Language } from './LanguagePicker.types'
import LanguagePickerView from './LanguagePickerView'

const LanguagePicker = () => {
    const { i18n } = useTranslation()
    const client = useApolloClient()

    const { data } = useQuery(LanguagePickerDocument)

    const availableLanguages = (data?.site?.languageOptions
        ?.map((option) => option?.value)
        .filter(Boolean) ?? []) as Language[]

    if (availableLanguages.length < 2) {
        return null
    }

    const viewerLanguage = data?.viewer?.language as Language | undefined
    const value =
        viewerLanguage && availableLanguages.includes(viewerLanguage)
            ? viewerLanguage
            : (data?.site?.language as Language | undefined)

    const handleChange = async (language: Language) => {
        createCookie('selected_language', language, 365)
        try {
            await i18n.changeLanguage(language)
            // Refetch all data so backend translations use the new language
            await client.resetStore()
        } catch (error) {
            console.error(error)
        }
    }

    return (
        <LanguagePickerView
            value={value}
            options={availableLanguages}
            onChange={handleChange}
        />
    )
}

export default LanguagePicker
